var map = {
	"./aparthotelclub/ic_tag_age.png": 48183,
	"./beachful/ic_tag_age.png": 54004,
	"./castlepedia/ic_tag_age.png": 87770,
	"./cocktayl/ic_tag_age.png": 18799,
	"./ic_tag_age.png": 5145,
	"./luxresortclub/ic_tag_age.png": 88046,
	"./parkful/ic_tag_age.png": 31826,
	"./prefabworld/ic_tag_age.png": 92676,
	"./rooftopclub/ic_tag_age.png": 37198,
	"./spaclub/ic_tag_age.png": 72457,
	"./worldcasino/ic_tag_age.png": 14648,
	"./zoopedia/ic_tag_age.png": 5633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87618;